import DataValidationReport from './DataValidationReport';

export default DataValidationReport;
